export const combineTwo = (path, route) => {
  return `${path}/${route}`.replace(/\/\//g, '/')
}

export const combine = (...params) => {
  return `${params.join('/')}`.replace(/\/{2,}/g, '/').replace(':/', '://')
}
